// cSpell:ignore flexbox, STYuanti, Unmount

import React from 'react';
import styled from 'styled-components';

import { Flex, Gift } from '../../lib/components/LessonPath/static/style';
import { Node, COURSE_TYPE } from '../../lib/components/LessonPath/static/json/constant';
import StepNode from '../../lib/components/LessonPath/step-node';

// let NodeIndex = 1;

export default class LessonNode extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            NodeIndex: 1,
            showDownloadDialog: false,
            hiddenDownload: false,
        }
    }

    // 点击下载
    clickDownloadHandler = () => {
        this.setState({
            showDownloadDialog: true
        });
    }

    // 隐藏下载按钮
    hiddenButtonHandler() {
        this.setState({
            hiddenDownload: true
        });
    }

    render() {
        const { data, onClick } = this.props;
        let { NodeIndex } = this.state;

        return (
            <LessonNodeBox>
                {hasNode('nodeKetExam', data) ?
                    <KetExamButton icons={data.lessonNode.nodeKetExam.imgUrl} onClick={() => onClick(
                        false,
                        "",
                        data.lessonNode.nodeKetExam.ketExamUrl,
                        "",
                        data.lessonNode
                    )}
                    >{data.lessonNode.nodeKetExam.ketExamName}</KetExamButton> : null}
                {hasNode('nodeGift', data) ?
                    <GiftButton onClick={() => onClick(
                        data.lessonNode.nodeGift.giftLocked,
                        data.lessonNode.nodeGift.giftMsg,
                        data.lessonNode.nodeGift.giftImgURL,
                        Node.gift,
                        data.lessonNode
                    )}
                    /> : null}
                {hasNode('nodeSummary', data) ?
                    <StepNode
                        text={data.lessonNode.nodeSummary.summaryName ? data.lessonNode.nodeSummary.summaryName : '学习'}
                        locked={data.lessonNode.nodeSummary.summaryLocked}
                        status={data.lessonNode.nodeSummary.summaryStatus}
                        imageUrl={data.lessonNode.nodeSummary.summaryImgURL}
                        star={data.lessonNode.nodeSummary.summaryStars}
                        integral={data.lessonNode.nodeSummary.summaryIntegral}
                        grapes={false}
                        type={Node.summary}
                        index={NodeIndex++}
                        activeLocation={data.lessonLocation}
                        onClick={() => onClick(
                            data.lessonNode.nodeSummary.summaryLocked,
                            data.lessonNode.nodeSummary.summaryMsg,
                            data.lessonNode.nodeSummary.summaryUrl,
                            Node.summary,
                            data.lessonNode
                        )}
                    />
                    : null}
                {hasNode('nodePreview', data) ?
                    <StepNode
                        text={data.lessonNode.nodePreview.previewName ? data.lessonNode.nodePreview.previewName : '预习'}
                        locked={data.lessonNode.nodePreview.previewLocked}
                        status={data.lessonNode.nodePreview.previewStatus}
                        imageUrl={null}
                        star={false}
                        integral={data.lessonNode.nodePreview.previewIntegral}
                        grapes={false}
                        type={Node.preview}
                        index={NodeIndex++}
                        activeLocation={data.lessonLocation}
                        onClick={() => onClick(
                            data.lessonNode.nodePreview.previewLocked,
                            data.lessonNode.nodePreview.previewMsg,
                            data.lessonNode.nodePreview.previewUrl,
                            Node.preview,
                            data.lessonNode
                        )}
                    />
                    : null}
                {hasNode('nodeLesson', data) ?
                    <StepNode
                        text={data.lessonNode.nodeLesson.lessonName ? data.lessonNode.nodeLesson.lessonName : '学习'}
                        locked={data.lessonNode.nodeLesson.lessonLocked}
                        status={data.lessonNode.nodeLesson.lessonStatus}
                        imageUrl={data.lessonNode.nodeLesson.lessonImgURL}
                        // star={data.lessonNode.nodeLesson.lessonStars}
                        star={false}
                        integral={data.lessonNode.nodeLesson.lessonIntegral}
                        grapes={false}
                        type={Node.lesson}
                        index={NodeIndex++}
                        activeLocation={data.lessonLocation}
                        data={data.lessonNode}
                        onClick={() => onClick(
                            data.lessonNode.nodeLesson.lessonLocked,
                            data.lessonNode.nodeLesson.lessonMsg,
                            data.lessonNode.nodeLesson.lessonUrl,
                            Node.lesson,
                            data.lessonNode
                        )}
                    />
                    : null}
                {hasNode('nodeHomework', data) ?
                    <StepNode
                        text={data.lessonNode.nodeHomework.homeworkName ? data.lessonNode.nodeHomework.homeworkName : '学习'}
                        locked={data.lessonNode.nodeHomework.homeworkLocked}
                        status={data.lessonNode.nodeHomework.homeworkStatus}
                        imageUrl={null}
                        star={false}
                        score={data.lessonNode.nodeType && data.lessonNode.nodeType === COURSE_TYPE.readingLesson
                            ? data.lessonNode.nodeHomework.homeworkGrapes
                            : null}
                        integral={data.lessonNode.nodeHomework.homeworkIntegral}
                        grapes={data.lessonNode.nodeHomework.homeworkGrapes}
                        type={Node.homework}
                        index={NodeIndex++}
                        activeLocation={data.lessonLocation}
                        onClick={() => onClick(
                            data.lessonNode.nodeHomework.homeworkLocked,
                            data.lessonNode.nodeHomework.homeworkMsg,
                            data.lessonNode.nodeHomework.homeworkURL,
                            Node.homework,
                            data.lessonNode
                        )}
                    />
                    : null}
                {hasNode('nodeReport', data) ?
                    <StepNode
                        text={data.lessonNode.nodeReport.reportName ? data.lessonNode.nodeReport.reportName : '学习'}
                        locked={data.lessonNode.nodeReport.reportLocked}
                        status={data.lessonNode.nodeReport.reportStatus}
                        imageUrl={data.lessonNode.nodeReport.reportImgURL}
                        star={data.lessonNode.nodeReport.reportStar}
                        integral={false}
                        grapes={false}
                        type={Node.report}
                        index={NodeIndex++}
                        activeLocation={data.lessonLocation}
                        onClick={() => onClick(
                            data.lessonNode.nodeReport.reportLocked,
                            data.lessonNode.nodeReport.reportMsg,
                            data.lessonNode.nodeReport.reportUrl,
                            Node.report,
                            data.lessonNode
                        )}
                    />
                    : null}
            </LessonNodeBox>
        );
    }
}

const hasNode = (node, data) => {
    if (data && data.lessonNode && data.lessonNode[node]) {
        return true;
    } else {
        return false;
    }
}

const LessonNodeBox = styled(Flex)`
    width: 100%;
    height: 5.04rem;
    justify-content: center;
`;

const GiftButton = styled(Gift)`
    position: fixed;
    top: 0.32rem;
    right: 0.67rem;
    cursor: pointer;
`;

const KetExamButton = styled.div`
    position: fixed;
    top: 0.4rem;
    right: 2.2rem;
    width: 2.2rem;
    height: 0.85rem;
    line-height: 0.85rem;
    padding-left: 1.1rem;
    border-radius: 1rem;
    background: rgba(0, 0, 0, 0.19);
    cursor: pointer;
    font-size: 0.32rem;
    color: #FFF;

    &::after {
        position: absolute;
        content: '';
        display: block;
        top: 0.05rem;
        left: 0.2rem;
        width: 0.75rem;
        height: 0.75rem;

        ${props => props.icons ? `
            background: url('${props.icons}') 0 center no-repeat;
            background-size: contain;
        ` : ''}
    }
`;


// case .trialLesson, .major
// 预习、学习、练一练、学习报告

// case .ctLesson
// 单元总结、学习、学习报告

// case .expandLesson
// 学习、练一练、学习报告

// case .readingLesson
// 预习、学习、练一练、学习报告


// WEBPACK FOOTER //
// ./src/components/lesson-path/lesson-node.js